module.exports = __webpack_public_path__ + "static/media/locationbuttonicon.6567e374.svg";